import { useSidePanelDiagonalCornerTab } from './hooks';

import { IMAGE_COMING_SOON, UNIT_MEASURE } from '~/core/constants';
import {
  CircleAction,
  DesignSection,
  DiagonalCornerOptions,
} from '~/core/enums';
import { getCornerType } from '~/core/helpers';
import { DiagonalCornerModel } from '~/core/models';
import {
  formatPriceUnitOrFree,
  getProductDescription,
  imgUrl,
} from '~/core/utils';
import SidePanelSectionTab from '~organisms/SidePanelSectionTab';

export const SidePanelDiagonalCornerTab = () => {
  const {
    isFetchingDiagonalCorners,
    diagonalCorners,
    handleUpdate,
    optionsCounters,
    totalVisibleCorners,
    isInteriorDiagonalCornerEnabled,
  } = useSidePanelDiagonalCornerTab();

  return (
    <SidePanelSectionTab<DiagonalCornerModel>
      section={DesignSection.DIAGONAL_CORNERS}
      hookArgs={{
        options: diagonalCorners,
        isFetching: isFetchingDiagonalCorners,
        stateRemoveOption: handleUpdate(CircleAction.REMOVE),
        stateAddOption: handleUpdate(CircleAction.ADD),
        optionsCounters,
        getId: (option) => option.productId,
        countersLimit: totalVisibleCorners,
        mapOptionToDisplay: (option) => ({
          title: getProductDescription(option),
          image: option.imageUrl
            ? imgUrl(option.imageUrl, 300)
            : IMAGE_COMING_SOON,
          price: formatPriceUnitOrFree(
            option.price,
            option.unitOfMeasure || UNIT_MEASURE.CORNER_RADIUS,
            true
          ),
          isDisabled:
            getCornerType(option) === DiagonalCornerOptions.INSIDE_CORNER &&
            !isInteriorDiagonalCornerEnabled,
        }),
      }}
    />
  );
};

export default SidePanelDiagonalCornerTab;
